export const OC_CATEGORY_START = Array.from(
	new Set([
		'EPL',
		'EFL Champ',
		'La Liga',
		'Bundesliga',
		'Serie A',
		'Ligue 1',
		'NFL',
		'NBA',
		'NHL',
	]),
);

export const US_CATEGORY_START = Array.from(
	new Set(['NFL', 'NBA', 'NCAAF', 'NCAAB', 'MLB', 'WNBA', 'NHL', 'MLS']),
);

export const US_CATEGORY_END = Array.from(
	new Set(['EPL', 'La Liga', 'Bundesliga', 'Serie A', 'Ligue 1', 'EFL Champ']),
);
